// -------------------------------------------------------------
// SETUP: GPU Accelerator
// -------------------------------------------------------------
gsap.config({ force3D: true });

// =============================================================
// SAMPLE 1: 左からひょっこり (Left Peek-a-boo) - 複数対応
// =============================================================
const peekElements = document.querySelectorAll(".js-peek");

peekElements.forEach((char) => {
  // 複数配置を考慮し、個別のホバーエリアを自動判別
  // (.left-peek-area という親要素があればそれを対象にし、無ければキャラクター自身をホバーエリアにする)
  const hoverArea = char.closest(".left-peek-area") || char;

  // 足元を起点に、少し右斜め前に傾かせた状態で画面外（左側）に隠す初期状態
  gsap.set(char, { x: "-120%", rotate: 15, transformOrigin: "bottom center" });

  // それぞれの要素ごとに独立したタイムラインを作成
  const peekTl = gsap.timeline({
    repeat: -1,
    repeatDelay: 2.5,
    delay: gsap.utils.random(0, 1.5), // 複数キャラの出現タイミングをランダムに分散
  });

  peekTl
    // 1. 左からひょっこり現れる
    .to(char, { x: "10%", rotate: -5, duration: 0.8, ease: "back.out(1.2)" })
    // 2. 出ている間に、嬉しそうに縦にピョコピョコ跳ねる
    .to(char, { y: -10, duration: 0.25, yoyo: true, repeat: 3, ease: "sine.inOut" })
    // 3. 元の位置へスッと引っ込む
    .to(char, { x: "-115%", rotate: 15, duration: 0.5, ease: "power3.in" });

  // 要素ごとに独立したホバー状態の管理変数
  let isMouseOver = false;

  hoverArea.addEventListener("mouseenter", () => {
    isMouseOver = true;
    peekTl.pause();
    // ビクッとして高速で左端へ隠れる
    gsap.to(char, { x: "-120%", rotate: 25, duration: 0.2, ease: "power4.in", overwrite: "auto" });
  });

  hoverArea.addEventListener("mouseleave", () => {
    isMouseOver = false;
    // 1.5秒のディレイを置いてから、この要素のひょっこり運動を再開
    gsap.delayedCall(1.5, () => {
      if (!isMouseOver) {
        peekTl.play(0);
      }
    });
  });
});

// =============================================================
// SAMPLE 2: 腹話術風・カタカタ左右ステップ (Chunky Puppetry) - 複数対応
// =============================================================
const chunkyElements = document.querySelectorAll(".js-chunky");

chunkyElements.forEach((char) => {
  gsap.set(char, { transformOrigin: "bottom center" });

  // 独立したタイムラインと、不揃いな開始タイミングを設定
  const puppetTl = gsap.timeline({
    repeat: -1,
    delay: gsap.utils.random(0, 1.2), // 同時スタートを防ぐランダムディレイ
  });

  puppetTl
    .to(char, { rotation: -12, x: -10, duration: 0.08, ease: "none" }) // 左にカクッ
    .to({}, { duration: 0.6 }) // 静止
    .to(char, { rotation: 12, x: 10, duration: 0.08, ease: "none" }) // 右にカクッ
    .to({}, { duration: 0.6 }) // 静止
    .to(char, { rotation: -8, x: -5, duration: 0.08, ease: "none" }) // 小さく左にカクッ
    .to({}, { duration: 0.3 }) // 静止
    .to(char, { rotation: 8, x: 5, duration: 0.08, ease: "none" }) // 小さく右にカクッ
    .to({}, { duration: 0.3 }) // 静止
    .to(char, { rotation: 0, x: 0, duration: 0.1, ease: "none" }) // 正面を向く
    .to({}, { duration: 1.5 }); // 長めの余韻
});

// =============================================================
// SAMPLE 3: ピョンピョン！ポップバウンド (Toy Pop & Bounce) - 複数対応
// =============================================================
const bounceElements = document.querySelectorAll(".js-bounce");

bounceElements.forEach((char) => {
  gsap.set(char, { transformOrigin: "bottom center" });

  const popTl = gsap.timeline({
    repeat: -1,
    repeatDelay: 2,
    delay: gsap.utils.random(0, 1.8), // 跳ねる周期をずらす
  });

  popTl
    .to(char, { scaleY: 0.82, scaleX: 1.15, duration: 0.22, ease: "power1.out" }) // ジャンプ前の溜め
    .to(char, { y: -50, scaleY: 1.12, scaleX: 0.9, duration: 0.32, ease: "power2.out" }) // 空中
    .to(char, { y: 0, scaleY: 1.04, scaleX: 0.96, duration: 0.25, ease: "power2.in" }) // 落下着地直前
    .to(char, { scaleY: 0.85, scaleX: 1.12, duration: 0.12, ease: "power1.out" }) // 着地の衝撃
    .to(char, { scaleY: 1, scaleX: 1, duration: 0.5, ease: "elastic.out(1.2, 0.4)" }); // 元に戻る
});
